import { createFileRoute } from '@tanstack/react-router'
import { FindTeamsDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import FindTeamsDialog from '@/routes/_app/-dialogs/find-teams'

export const Route = createFileRoute('/@modal/teams/find')({
  staticData: { slotScope: '/_app/teams' },
  pendingComponent: FindTeamsDialogPending,
  component: FindTeamsSlot,
})

function FindTeamsSlot() {
  const slot = useModalSlot(Route)
  return <FindTeamsDialog {...slot} />
}
